import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store';
import CustomSlideInContent from '../misc/CustomSlideInContent';
import { selectSelectedAgreement } from '../../store/general/general-slice-selectors';
import { setSelectedAgreementId } from '../../store/general/general-slice';
import AgreementInfo from './AgreementInfo';

const AgreementOverlay: React.FC = () => {
  const dispatch = useAppDispatch();

  const selectedAgreement = useAppSelector((state) => selectSelectedAgreement(state));

  const [searchFilter, setSearchFilter] = useState('');
  const [isSliderOpen, setIsSliderOpen] = useState(selectedAgreement != null);

  useEffect(() => {
    if (selectedAgreement == null && isSliderOpen) {
      setIsSliderOpen(false);
    } else if (selectedAgreement != null && !isSliderOpen) {
      setIsSliderOpen(true);
    }
  }, [dispatch, isSliderOpen, selectedAgreement]);

  const closeOverlayClickHandler = () => {
    dispatch(setSelectedAgreementId(null));
    setIsSliderOpen(false);
  };

  const searchFilterChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchFilter(event.target.value);
  };

  return (
    <React.Fragment>
      <CustomSlideInContent
        data-testId="custom-slide-in"
        open={isSliderOpen}
        ChildComponent={AgreementInfo}
        childProps={{ agreement: selectedAgreement, onClose: () => {} }}
        search={{ searchFilter, onChange: searchFilterChangeHandler }}
        onCloseOverlay={closeOverlayClickHandler}
      />
    </React.Fragment>
  );
};

export default AgreementOverlay;
